import { useEffect, useState } from 'react';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { last2Week } from 'components/Form/WeekRangePicker/utils';
import useOperations from 'data/hooks/useOperations';
import { toApiDayFormat } from 'utils/date';
import { HoverRange } from 'data/types/hoverRange';
import { Props, DeliveryBrands } from './types';

const useConnect = ({ brandId }: Props) => {
  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [integration, setIntegration] =
    useState<DeliveryBrands>('ubereats_manager');
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(
    getWeekDays(last2Week),
  );
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };
  const { operations, isLoading, refetch } = useOperations({
    brandId,
    integration,
    dateStart: toApiDayFormat(selectedDays[0]),
    dateEnd: toApiDayFormat(selectedDays[6]),
  });
  const datesCopy = [...selectedDays];
  const firstDate = datesCopy.shift();
  const lastDate = datesCopy.pop();
  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId, integration, firstDate, lastDate]);
  return {
    operations,
    isLoading,
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    integration,
    setIntegration,
  };
};

export default useConnect;
